'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M978.84 256.252c-10.588 0-21.458 3.722-31.436 10.766l-179.404 126.614v-105.632c0-52.8-43.2-96-96-96h-576c-52.8 0-96 43.2-96 96v448c0 52.8 43.2 96 96 96h576c52.8 0 96-43.2 96-96v-105.63l179.402 126.614c9.978 7.042 20.848 10.764 31.434 10.766 0.002 0 0.002 0 0.006 0 14.088 0 26.954-6.496 35.292-17.822 6.456-8.77 9.868-20.054 9.868-32.636v-410.582c-0.002-33.126-22.72-50.458-45.162-50.458z' })
    ));
};